import { EcoWidget } from "@waldner-laboreinrichtungen/component-system";
import type { FC } from "react";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

import type { EcoStats } from "../hooks/use-eco";
import { EcoModal } from "./eco-modal";
import { ErrorScreenWithText } from "./error-screen";

export const EcoWidgetPartial: FC<{
  error?: Error;
  isLoading: boolean;
  stats?: EcoStats;
}> = ({ error, isLoading, stats }) => {
  const [openEcoModal, setEcoModal] = useState(false);
  const { t } = useTranslation();

  if (error) {
    return <ErrorScreenWithText error={error} />;
  }

  if (!stats) {
    return <ErrorScreenWithText error={new Error("no info")} />;
  }

  const infoTexts = [];
  if (isLoading) infoTexts.push(t("eco.widget.analyzing"));
  else if (stats.usage.total === 0)
    infoTexts.push(t("eco.widget.no-workplaces"));
  else {
    infoTexts.push(
      `${stats.usage?.open} ${t("eco.widget.open")}`,
      `${stats.usage?.low} ${t("eco.widget.low")}`,
      `${stats.messages?.length} ${t("eco.widget.optimizations")}`
    );
  }
  return (
    <Fragment>
      <EcoWidget
        buttonText={t("eco.widget.details")}
        fillValue={Number.isFinite(stats.index) ? Number(stats.index) : 0}
        infoTexts={infoTexts}
        key="widget"
        onClick={() => setEcoModal(true)}
        subtitle={t("eco.widget.workplace")}
        title={t("eco.widget.title")}
      />
      <EcoModal
        buttonText={t("eco.modal.close")}
        emptyText={t("eco.modal.emptytext")}
        emptyTitle={t("eco.modal.emptytitle")}
        key="modal"
        labelDevices={t("eco.modal.label.devices")}
        labelRecommendation={t("eco.modal.label.recommendation")}
        onClose={() => setEcoModal(false)}
        open={openEcoModal}
        recommendations={stats.messages}
        title={t("eco.modal.title")}
      >
        XXX
      </EcoModal>
    </Fragment>
  );
};
